// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"0d00be89","268":"ca8a286d","563":"9dff60a5","581":"a9c9271a","951":"2d3418c7"}[chunkId] + ".chunk.js";
};